import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import GenerateActivatedQRCodesForm from './GenerateActivatedQRCodesForm'

const GenerateActivatedQRCodesModal = props => {
  return (
    <ControlledModal width="32rem" disableClickOutside {...props}>
      <MultiSelectHandler>
        <ModalHeader />
        <GenerateActivatedQRCodesForm />
      </MultiSelectHandler>
    </ControlledModal>
  )
}

export default GenerateActivatedQRCodesModal
